import { useEffect, useState } from 'react';
import { requestJsonData } from '~/utils/request-json-data';

export function useCacheFetch({
  url,
  forceFresh,
  sessionStorageRevalidate = 600_000,
}: {
  url: string | null | undefined;
  forceFresh?: boolean;
  sessionStorageRevalidate?: number;
}): {
  isLoading: boolean;
  jsonData: any;
} {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [jsonData, setJsonData] = useState<any>(null);

  useEffect(() => {
    if (!url) return;

    (async () => {
      setIsLoading(true);

      const response = await requestJsonData({
        url,
        sessionStorageKey: forceFresh ? undefined : url,
        sessionStorageRevalidate,
      });

      if (response) setJsonData(response);

      setIsLoading(false);
    })();

    return () => {
      setJsonData(null);
      setIsLoading(false);
    };
  }, [url]);

  return { isLoading, jsonData };
}
